import React from "react";
import { DESIGN_STAGES, STAGE_INDEX } from "@/lib/design";
import { Check, Lock } from "lucide-react";

export default function StatusTracker({ project, canEdit, onChange }) {
  const idx = STAGE_INDEX[project.status] ?? 0;

  return (
    <div>
      <p className="text-[10px] font-mono uppercase tracking-[0.3em] text-gray-500 mb-3">Design status</p>
      <div className="space-y-1.5">
        {DESIGN_STAGES.map((s, i) => {
          const active = i === idx;
          const done = i < idx;
          const isProd = s.id === "production_ready";
          const disabled = isProd || !canEdit;
          return (
            <button
              type="button"
              key={s.id}
              disabled={disabled}
              onClick={() => onChange(s.id)}
              className={`w-full flex items-center gap-3 p-2 rounded-md border transition-colors text-left ${
                active ? "border-[#d4af37] bg-[#d4af37]/5"
                : done ? "border-[#1a1a1a] bg-[#0e0e0e]"
                : "border-[#262626] hover:border-[#3a3a3a]"
              } ${disabled ? "opacity-70 cursor-not-allowed" : ""}`}
              data-testid={`stage-${s.id}`}
            >
              <span className={`w-5 h-5 rounded-full border flex items-center justify-center flex-shrink-0 ${
                done ? "bg-[#d4af37] border-[#d4af37] text-black"
                : active ? "border-[#d4af37] bg-[#d4af37]/10 text-[#d4af37]"
                : "border-[#3a3a3a] text-gray-600"
              }`}>
                {done ? <Check className="w-3 h-3"/> : isProd ? <Lock className="w-3 h-3"/> : <span className="text-[9px] font-mono">{i + 1}</span>}
              </span>
              <span className={`text-sm ${active ? "text-white" : done ? "text-gray-400" : "text-gray-500"}`}>
                {s.label}
                {s.id === "design_iterations" && project.iteration_count > 0 && (
                  <span className="ml-2 text-[10px] font-mono text-[#d4af37]">· {project.iteration_count} shared</span>
                )}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
